import { Shield, UserX, Heart, Lock, Clock, Smile } from "lucide-react";
import { motion } from "motion/react";

const features = [
  {
    icon: UserX,
    title: "Anonymous",
    description: "Talk freely without revealing your identity. Your privacy is our priority.",
    color: "from-purple-400 to-purple-600",
  },
  {
    icon: Shield,
    title: "Safe",
    description: "All conversations are encrypted and confidential. Feel secure sharing your emotions.",
    color: "from-blue-400 to-blue-600",
  },
  {
    icon: Heart,
    title: "Supportive",
    description: "Connect with trained listeners who genuinely care about your wellbeing.",
    color: "from-pink-400 to-pink-600",
  },
  {
    icon: Lock,
    title: "Private",
    description: "No recordings, no data sharing. What you say stays between you and your listener.",
    color: "from-purple-400 to-pink-500",
  },
  {
    icon: Clock,
    title: "24/7 Available",
    description: "Listeners are available around the clock whenever you need someone to talk to.",
    color: "from-blue-400 to-purple-500",
  },
  {
    icon: Smile,
    title: "Judgment-Free",
    description: "Express yourself openly in a space free from judgment or criticism.",
    color: "from-pink-400 to-purple-500",
  },
];

export default function Features() {
  return (
    <section id="features" className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose FeelTalk?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            A safe, supportive space designed with your emotional wellbeing in mind
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group p-8 bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl hover:shadow-xl transition-all duration-300 border border-purple-100"
              >
                <div className={`w-14 h-14 bg-gradient-to-br ${feature.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
